import { HOME_LANDING_FONT_FAMILY } from '@/components/home-landing/home-landing-font';

export const MARKETING = {
  canvas: '#1E1915',
  text: '#EFE8DC',
  muted: '#DBD1C0',
  taupe: '#B8AD9A',
  accent: '#9B2C22',
  ink: '#17140F',
  hairline: 'rgba(239, 232, 220, 0.12)',
  hairlineStrong: 'rgba(239, 232, 220, 0.22)',
  body: 'rgba(239, 232, 220, 0.74)',
  intro: 'rgba(239, 232, 220, 0.8)',
  dim: 'rgba(239, 232, 220, 0.42)',
  ghost: 'rgba(239, 232, 220, 0.22)',
  indexIdle: 'rgba(239, 232, 220, 0.42)',
  ease: 'cubic-bezier(0.2, 0.6, 0.2, 1)',
  padX: { xs: '20px', sm: '32px', md: '44px' },
  sans: HOME_LANDING_FONT_FAMILY,
  serif: 'var(--font-newsreader), serif',
  beVietnam: 'var(--font-be-vietnam), sans-serif',
};

/** In-flow marketing nav (logo + HOME_NAV_BAR_PY + 1px border). Keep in sync with MarketingInteriorNav. */
export const MARKETING_INTERIOR_NAV_HEIGHT = { xs: '4.5rem', md: '5.25rem' };

/** Floor so landscape phones keep copy + scroll CTA readable (page may scroll slightly). */
export const MARKETING_HERO_MIN_HEIGHT_PX = 520;

export const MARKETING_HERO_SECTION_SX = {
  '--marketing-hero-nav-offset': MARKETING_INTERIOR_NAV_HEIGHT.xs,
  '@media (min-width: 900px)': {
    '--marketing-hero-nav-offset': MARKETING_INTERIOR_NAV_HEIGHT.md,
  },
  height: 'calc(100svh - var(--marketing-hero-nav-offset))',
  '@supports (height: 100dvh)': {
    height: 'calc(100dvh - var(--marketing-hero-nav-offset))',
  },
  minHeight: MARKETING_HERO_MIN_HEIGHT_PX,
};

export const MARKETING_EYEBROW_SX = {
  fontFamily: MARKETING.sans,
  fontWeight: 400,
  fontSize: '10px',
  letterSpacing: '0.32em',
  textTransform: 'uppercase',
  color: MARKETING.taupe,
};

export const MARKETING_HEADING_SX = {
  m: 0,
  fontFamily: MARKETING.serif,
  fontWeight: 300,
  fontSize: { xs: 'clamp(32px, 8vw, 50px)', md: '50px' },
  lineHeight: 1.1,
  letterSpacing: '-0.015em',
};

export const MARKETING_BODY_SX = {
  m: 0,
  maxWidth: 720,
  fontFamily: MARKETING.sans,
  fontWeight: 400,
  fontSize: '15px',
  lineHeight: 1.95,
  color: MARKETING.body,
  textWrap: 'pretty',
};

export const MARKETING_NUM_SX = {
  fontFamily: MARKETING.serif,
  fontWeight: 300,
  fontSize: '46px',
  lineHeight: 1,
  color: MARKETING.ghost,
};

export const MARKETING_SOLID_CTA_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: MARKETING.sans,
  fontWeight: 500,
  fontSize: '11px',
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  bgcolor: MARKETING.text,
  color: MARKETING.ink,
  px: '32px',
  py: '16px',
  textDecoration: 'none',
  '&:hover': {
    bgcolor: MARKETING.muted,
    color: MARKETING.ink,
  },
};

export const MARKETING_TEXT_CTA_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  fontFamily: MARKETING.sans,
  fontWeight: 500,
  fontSize: '11px',
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  color: 'rgba(239, 232, 220, 0.8)',
  borderBottom: '1px solid rgba(239, 232, 220, 0.45)',
  pb: '6px',
  textDecoration: 'none',
  '&:hover': {
    color: MARKETING.muted,
  },
};
